import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  MemberSummaryFeedbackDialog,
  MemberSummaryFeedbackDialogCallbackInput,
  MemberSummaryFeedbackDialogUniqueProps,
} from '../MemberSummaryFeedbackDialog';

const { useDialogForContext, useDialog: useMemberSummaryFeedbackDialog } =
  getDialogHooks<
    MemberSummaryFeedbackDialogUniqueProps,
    MemberSummaryFeedbackDialogCallbackInput
  >(MemberSummaryFeedbackDialog);
export const useMemberSummaryFeedbackDialogForContext = useDialogForContext;
export default useMemberSummaryFeedbackDialog;
